// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';

// js utilities
import _ from 'lodash';

// import components from material UI
import RaisedButton from 'material-ui/RaisedButton';
import muiThemeable from 'material-ui/styles/muiThemeable';

const raisedButtonCustomization = {
  primary: true,
  disableTouchRipple: true,
  disableFocusRipple: true,
  style: {
    display: 'inline-flex',
    alignItems: 'center',
    minWidth: '296px',
    height: '41px'
  },
  labelStyle: {
    letterSpacing: '3.5px',
    fontSize: '12px',
    verticalAlign: 'initial',
    top: '-.5px'
  },
  disabledBackgroundColor: 'rgb(241,241,241)'
};


@muiThemeable()  // muiThemeable brings in theme from provider at root
export default class CustomRaisedButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    style: PropTypes.object,
    labelStyle: PropTypes.object
  }

  static defaultProps = {
    style: {},
    labelStyle: {}
  }

  constructor(props, context) {
    super(props, context);
  }

  render() {
    const {
      className,
      label,
      style,
      labelStyle,
      ...otherProps
    } = this.props;

    const {
      style: raisedButtonCustomizationStyle,
      labelStyle: raisedButtonCustomizationLabelStyle,
      ...raisedButtonCustomizationOther
    } = raisedButtonCustomization;

    const rootStyleFinal = {...raisedButtonCustomizationStyle, ...style};

    return (
      <RaisedButton className={`raised-button ${className} ${otherProps.disabled ? 'disabled' : ''}`}
                    data-id={`${label}${otherProps.disabled ? ' Disabled' : ''}`}
                    label={label}
                    style={rootStyleFinal}
                    labelStyle={{...raisedButtonCustomizationLabelStyle, lineHeight: `${rootStyleFinal.height}${typeof rootStyleFinal.height === 'string' && !isNaN(rootStyleFinal.height.slice(-2)) ? 'px' : ''}`, ...labelStyle}}
                    {...raisedButtonCustomizationOther}
                    {...otherProps}/>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_RaisedButton/index.js